import React, { useState, useEffect, useContext } from "react";
import {
  FaChevronDown,
  FaChevronLeft,
  FaEdit,
  FaSignOutAlt,
  FaUserCircle,
  FaKey,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import { CustomerContext } from "../context/customerContext";

export const PAGE_CONTAINER = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";

const DashboardLayout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  // const [customer, setCustomer] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { customer,customerError, setCustomer } = useContext(CustomerContext);
  const toPersianDigits = (num) =>
    num.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchCustomer = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       if (!token) {
  //         navigate("/login");
  //         return;
  //       }

  //       const response = await axios.get(
  //         // "http://172.30.11.101:5050/api/Customer/CustomerInfo",
  //         "/Customer/CustomerInfo"
  //       );
  //       setCustomer(response.data);
  //     } catch (error) {
  //       console.error("خطا در دریافت اطلاعات مشتری:", error);
  //       navigate("/login");
  //     }
  //   };

  //   fetchCustomer();
  // }, []);

  const signOut = async () => {
    try {
      const response = await axios.post("/Auth/SignOut");
      localStorage.removeItem("token");
      setCustomer(null);
      navigate("/login");
    } catch (error) {
      console.error("خطا در گرفتن لیست مشتری‌ها:", error);
    }
  };

  const customerName = customer?.customerName || "";
  const customerId = customer ? `کد مشتری: ${customer.customerCode}` : "";

  if (customerError) {
  return (
    <div
      className="flex items-center justify-center min-h-screen bg-gray-50"
      dir="rtl"
    >
      <div className="bg-white p-6 rounded-xl shadow-md text-center max-w-md">
        <p className="text-red-600 font-semibold text-sm leading-7">
          {customerError}
        </p>

        <button
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md text-sm"
          onClick={() => {
            localStorage.removeItem("token");
            setCustomer(null);
            navigate("/login");
          }}
        >
          بازگشت به صفحه ورود
        </button>
      </div>
    </div>
  );
}


  if (!customer) {
    return (
      <div className="flex justify-center items-center h-screen text-blue-800">
        در حال بارگذاری اطلاعات...
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-blue-100 to-white relative"
      dir="rtl"
    >
      {/* ✅ Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-white shadow-md">
        {/* <div className="flex items-center gap-3 text-right">
            <FaUserCircle className="text-blue-800 text-3xl" />
            <div className="flex flex-col text-blue-900 text-sm">
              <span className="font-bold">{customerName}</span>
              <span className="text-xs text-gray-600">{customerId}</span>
            </div>
          </div> */}
        <div className="relative text-right">
          <div
            onClick={() => setDropdownOpen((prev) => !prev)}
            className="flex items-center gap-3 cursor-pointer"
          >
            <FaUserCircle className="text-blue-800 text-3xl" />
            <div className="flex flex-col text-blue-900 text-sm">
              <span className="font-bold">{customerName}</span>
              <span className="text-xs text-gray-600">{customerId}</span>
            </div>
          </div>

          {dropdownOpen && (
            <div className="absolute top-full right-0 mt-2 bg-white border rounded shadow-md z-50 w-44 text-sm">
              <button
                className="w-full text-right px-4 py-2 hover:bg-gray-100 text-red-600"
                onClick={() => {
                  signOut();
                }}
              >
                خروج از حساب
              </button>
            </div>
          )}
        </div>

        <button
          onClick={() => setMenuOpen(true)}
          className="text-blue-800 hover:text-blue-600 transition"
        >
          <FaChevronDown className="text-xl" />
        </button>
      </header>

      {/* ✅ Content */}
      {/* <main className="max-w-7xl mx-auto py-8 px-4">
          {React.isValidElement(children)
            ? React.cloneElement(children, { customer })
            : children}
        </main> */}
      <main className={`${PAGE_CONTAINER} py-8`}>
        {React.isValidElement(children)
          ? React.cloneElement(children, { customer })
          : children}
      </main>

      {/* ✅ Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 z-50 ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4 flex justify-between items-center border-b">
          <span className="font-bold text-blue-900">پروفایل</span>
          <button onClick={() => setMenuOpen(false)}>
            <FaChevronLeft />
          </button>
        </div>
        <div className="p-4 space-y-3 text-sm text-blue-900">
          {/* <button className="flex items-center gap-2 w-full hover:bg-blue-100 px-2 py-2 rounded">
              <FaEdit /> ویرایش پروفایل
            </button> */}
          <button
            className="flex items-center gap-2 w-full hover:bg-blue-100 px-2 py-2 rounded"
            onClick={() => {
              signOut();
            }}
          >
            <FaSignOutAlt /> خروج از حساب
          </button>
          <button
            className="flex items-center gap-2 w-full hover:bg-blue-100 px-2 py-2 rounded"
            onClick={() => {
              navigate("/forgot-password");
            }}
          >
            <FaKey /> فراموشی رمز عبور
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default DashboardLayout;
